// extracted by mini-css-extract-plugin
export default {"input":"Availability_input__j-gIl","inventory":"Availability_inventory__84Eml","out_of_stock":"Availability_out_of_stock__xZUwM"};